import type { Property } from '../models'
import type { ToZod } from '@kubb/plugin-zod/utils'
import { propertyNumberSchema } from './propertyNumberSchema'
import { propertySectionSchema } from './propertySectionSchema'
import { propertySelectSchema } from './propertySelectSchema'
import { z } from 'zod'

export const propertySchema = z.union([
  z.lazy(() => propertySelectSchema),
  z.lazy(() => propertyNumberSchema),
  z.lazy(() => propertySectionSchema),
]) as unknown as ToZod<Property>

export type PropertySchema = Property